import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from './utils/axiosConfig';
import { useLocation } from 'react-router-dom';
import { recordLoginInfo } from './services/recordLoginInfo';
const REACT_APP_LINE_CHANNEL_ID = process.env.REACT_APP_LINE_CHANNEL_ID;
const REACT_APP_LINE_REDIRECT_URI = process.env.REACT_APP_LINE_REDIRECT_URI;

const LoginPage = () => {
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginType, setLoginType] = useState('line'); // 預設為 LINE 登入
  const [needMobile, setNeedMobile] = useState(false); // 是否需要輸入手機號
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const message = queryParams.get('message');
    const needMobileParam = queryParams.get('needMobile');
    const errorParam = queryParams.get('error');
    
    if (message) {
      if (errorParam) {
        setErrorMessage(decodeURIComponent(message));
      } else {
        setSuccessMessage(decodeURIComponent(message));
      }
    }
    
    if (needMobileParam === 'true') {
      setNeedMobile(true);
      setLoginType('mobile-binding');
    }
  }, [location]);

  // 手機號登入處理邏輯
  const handleMobileLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/login/mobile', { mobile });

      const { user, token, message } = response.data;
      


      localStorage.setItem('token', token);
      localStorage.setItem('user.loginType', '1'); // 手機號登入類型為 1


      const userInfo = {
        e_id: user.e_id,
        e_ssid: user.e_ssid,
        e_name: user.e_name,
        e_position: user.e_position,
        e_mobile: user.e_mobile,
        token: token,
      };
       // 記錄登入資訊
       await recordLoginInfo(userInfo);

      if (user.e_line_id) {
        // 如果已經綁定 LINE，直接顯示成功訊息並跳轉
        setSuccessMessage('登入成功，已綁定 LINE，將跳轉到首頁...');
        window.location.href = `/?token=${token}`;
      } else {
        // 如果未綁定 LINE，詢問用戶是否要綁定
        if (window.confirm("您尚未綁定 LINE，是否進行綁定？")) {
          handleLineLogin();
        } else {
          // 使用者選擇不綁定，直接登入
          setSuccessMessage('成功登入，將跳轉到首頁...');
          window.location.href = `/?token=${token}`;
        }
      }
    } catch (error) {
      setErrorMessage('登入失敗，請跟秘書確認手機是否建檔');
    }
  };

  // Email + 密碼登入邏輯
  const handleEmailPasswordLogin = async (e) => {
    e.preventDefault();
    
    try {
      const response = await axios.post('/login/email', { email, password });

      const { user, token } = response.data;
      
      // 儲存 token 和用戶資訊
      localStorage.setItem('token', token);
      localStorage.setItem('user.loginType', '2'); // 密碼登入類型為 2

      const userInfo = {
        e_id: user.e_id,
        e_ssid: user.e_ssid,
        e_name: user.e_name,
        e_position: user.e_position,
        e_email: user.e_email,
        token: token,
      };

      // 記錄登入資訊
      await recordLoginInfo(userInfo);
      
      setSuccessMessage('登入成功，將跳轉到首頁...');
      setTimeout(() => {
        window.location.href = `/?token=${token}`;
      }, 1000);
      
    } catch (error) {
      if (error.response?.status === 400) {
        setErrorMessage('帳號或密碼錯誤');
      } else {
        setErrorMessage('登入失敗，請稍後再試');
      }
    }
  };

  // LINE 授權登入邏輯
  const handleLineLogin = () => {
    const clientId = process.env.REACT_APP_LINE_CHANNEL_ID || '2000402227';
    const redirectUri = encodeURIComponent(process.env.REACT_APP_LINE_REDIRECT_URI || 'https://twrc.li.com.tw/callback');
    
    // 根據不同狀況設定 state
    let state = 'login_only';
    if (needMobile && mobile) {
      state = `mobile_${mobile}`;
    }
    
    const lineAuthUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=profile%20openid`;
    window.location.href = lineAuthUrl;
  };

  // 手機號綁定提交
  const handleMobileBinding = (e) => {
    e.preventDefault();
    if (!mobile.trim()) {
      setErrorMessage('請輸入手機號碼');
      return;
    }
    // 提交手機號並進行 LINE 綁定
    handleLineLogin();
  };

  


  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body>
              <h1 className="text-center mb-4">TWRC 登入</h1>

              {successMessage && (
                <div className="alert alert-success text-center">
                  {successMessage}
                </div>
              )}

              {errorMessage && (
                <div className="alert alert-danger text-center">
                  {errorMessage}
                </div>
              )}

              {/* 手機號綁定表單 */}
              {needMobile && loginType === 'mobile-binding' && (
                <div>
                  <div className="alert alert-info text-center">
                    <i className="fas fa-info-circle"></i> 新用戶需要綁定手機號
                  </div>
                  <Form onSubmit={handleMobileBinding}>
                    <Form.Group controlId="formMobileBinding" className="mb-3">
                      <Form.Label>請輸入您的手機號碼：</Form.Label>
                      <Form.Control
                        type="tel"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        placeholder="例如：0912345678"
                        required
                      />
                      <Form.Text className="text-muted">
                        請輸入您在系統中註冊的手機號碼進行 LINE 綁定
                      </Form.Text>
                    </Form.Group>
                    <Button variant="success" type="submit" className="w-100 mb-3">
                      <i className="fab fa-line"></i> 綁定 LINE 並登入
                    </Button>
                  </Form>
                  <div className="text-center">
                    <Button 
                      variant="link" 
                      onClick={() => {
                        setNeedMobile(false);
                        setLoginType('line');
                        setErrorMessage('');
                      }}
                    >
                      返回登入頁面
                    </Button>
                  </div>
                </div>
              )}

              {/* 主要登入介面 */}
              {!needMobile && (
                <div>
                  {/* 主要 LINE 登入按鈕 */}
                  <div className="text-center mb-4">
                    <Button 
                      variant="success" 
                      size="lg" 
                      className="w-100 mb-3"
                      onClick={handleLineLogin}
                      style={{ 
                        padding: '15px', 
                        fontSize: '18px',
                        fontWeight: 'bold'
                      }}
                    >
                      <i className="fab fa-line me-2"></i> 使用 LINE 登入
                    </Button>
                    <small className="text-muted">推薦登入方式</small>
                  </div>

                  <hr className="my-4" style={{ display: 'none' }} />

                  {/* 其他登入方式 */}
                  <div className="text-center mb-3" style={{ display: 'none' }}>
                    <small className="text-muted">其他登入方式</small>
                  </div>

                  <div className="text-center mb-4" style={{ display: 'none' }}>
                    <Button 
                      variant={loginType === 'password' ? 'primary' : 'outline-primary'}
                      onClick={() => setLoginType('password')}
                      className="me-2"
                      size="sm"
                    >
                      Email 登入
                    </Button>
                    <Button 
                      variant={loginType === 'mobile' ? 'warning' : 'outline-warning'}
                      onClick={() => setLoginType('mobile')}
                      size="sm"
                    >
                      手機號登入
                    </Button>
                  </div>

                  {/* Email 密碼登入表單 */}
                  {loginType === 'password' && (
                    <div style={{ display: 'none' }}>
                      <Form onSubmit={handleEmailPasswordLogin}>
                        <Form.Group controlId="formEmail" className="mb-3">
                          <Form.Label>Email:</Form.Label>
                          <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="請輸入 Email"
                            required
                          />
                        </Form.Group>
                        <Form.Group controlId="formPassword" className="mb-3">
                          <Form.Label>密碼:</Form.Label>
                          <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="請輸入密碼"
                            required
                          />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100">
                          登入
                        </Button>
                      </Form>
                    </div>
                  )}

                  {/* 手機號登入表單 */}
                  {loginType === 'mobile' && (
                    <div style={{ display: 'none' }}>
                      <Form onSubmit={handleMobileLogin}>
                        <Form.Group controlId="formMobile" className="mb-3">
                          <Form.Label>手機號碼:</Form.Label>
                          <Form.Control
                            type="tel"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            placeholder="請輸入手機號"
                            required
                          />
                        </Form.Group>
                        <Button variant="warning" type="submit" className="w-100">
                          手機號登入
                        </Button>
                      </Form>
                    </div>
                  )}
                </div>
              )}

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
